import { jsx as l } from "react/jsx-runtime";
import { c as n } from "react/compiler-runtime";
import { Skeleton as f } from "@mui/material";
function s(r) {
  const e = n(4);
  let o;
  e[0] !== r ? ({
    ...o
  } = r, e[0] = r, e[1] = o) : o = e[1];
  let t;
  return e[2] !== o ? (t = /* @__PURE__ */ l(f, { ...o }), e[2] = o, e[3] = t) : t = e[3], t;
}
export {
  s as Skeleton
};
